




































import {Component, Prop} from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import CodeDiff from 'vue-code-diff';
import ListUtils from '@/lib/listUtils';

@Component({ name: 'DiffDialog', components: { CodeDiff } })
export default class extends SaascadaVueDialog {

    outputFormat: string = "side-by-side";

    @Prop({required: true})
    current: string;

    @Prop({required: true})
    previous: string;

    get outputFormats() {
        return ListUtils.compareOutputFormats();
    }

    get oldString() {
        return JSON.stringify(this.previous, null, 4);
    }

    get newString() {
        return JSON.stringify(this.current, null, 4);
    }

}
